module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.860c3ec7.ttf";